module.exports = __webpack_public_path__ + "media/images/departments-74745e876776d0fc4e1ea67a4db93eae.svg";